import BasePage from './BasePage';
import React from 'react';
import Page from '../components/Page';
import {Button, ButtonGroup, Card, CardBody, CardHeader, Col, Collapse, FormGroup, Input, Label, Row} from 'reactstrap';
// import label from '../message/Label'
import label from 'enqc-utilities/src/label/Label'
import {BsListTask, FaUser, MdArrowDropDown, MdArrowDropUp, MdCancel, MdHelp, MdSave} from "react-icons/all";
import Endpoint from "enqc-utilities/src/api/Endpoint";
import ReleaseVerificationFormLaneCheckWidget from "../components/Widget/ReleaseVerificationFormLaneCheckWidget";
import InspectionGuideModal from "../components/modal/InspectionGuideModal";
import CustomerInfoUnchangeableModal from "../components/modal/CustomerInfoUnchangeableModal";
import InspectionDetailModal from "../components/modal/InspectionDetailModal";
import {isEmpty} from "../utils/Utilities";
import ConfirmReleaseVerificationFormModal from "../components/modal/ConfirmReleaseVerificationFormModal";
import ConfirmReleaseVerificationSubmitModal from "../components/modal/ConfirmReleaseVerificationSubmitModal";
import OutgoingDashboardPage from "./OutgoingDashboardPage";
import {RELEASE_STATUS_POSTPONED} from "enqc-utilities/src/utils/Global";
import ConfirmReleaseVerificationCancelModal from "../components/modal/ConfirmReleaseVerificationCancelModal";
import PrimaryCardHeader from "../components/Widget/PrimaryCardHeader";

var clone = require('safe-clone-deep');

class ReleaseVerificationFormCheckPage extends BasePage{

    constructor(props) {
        super(props);
        let reference = (this.props.match&&this.props.match.params&&this.props.match.params.reference)
            ?this.props.match.params.reference:""
        if(!reference){
            this.props.history.goBack();
        }
        let state = this.state
        state.releaseVerification = {}
        state.releaseVerificationEvents = []
        state.releaseVerificationStatusSubmitOptions = [{},{}]
        state.reference = reference
        state.inspectionDetailModal = false

        state.stepNumber = 0
        state.expandInfo = true
        state.justOpen = true
        state.customerInfoModal = false ;
        state.inspectionGuideModal = true ;
        state.confirmReleaseVerificationModal = false
        state.confirmReleaseVerificationSubmitModal = false
        state.confirmReleaseVerificationCancelModal = false
        state.serialCodeHasBeenUsedMessage = "" ;
        state.serialCodeHasBeenUsedModal = false ;
        state.anotherMatchSerialReleaseVerification = {}
        state.generateSerialNumber = false
        state.commitReleaseVerificationSuccessDialog = false
        state.tokenInputModal = false
        state.inspectionDetailModal = false
        state.rectifierControllerSerialNumberInfoModal = false
        this.setState(state)
    }

    async componentDidMount() {
        super.componentDidMount();
        await this.fetchReleaseVerificationDetail()
        await this.fetchReleaseVerificationStatusSubmitOptions()
    }

    fetchReleaseVerificationDetail = async () =>{
        this.showProgress()
        let response = await this.asyncGet(Endpoint.API.RELEASE_VERIFICATION, {
            params :{
                reference : this.state.reference
            }
        }, null, false, true)
        if(response.code===200){
            let releaseVerification = response.data
            this.setState({
                releaseVerification
            })
        }
        this.closeProgress()

    }

    fetchReleaseVerificationStatusSubmitOptions = async () =>{
        let response = await this.asyncGet(Endpoint.API.RELEASE_VERIFICATION_STATUS_SUBMIT_OPTIONS, null, null, false, true)
        if(response.code===200){
            let releaseVerificationStatusSubmitOptions = response.data
            this.setState({
                releaseVerificationStatusSubmitOptions:releaseVerificationStatusSubmitOptions
            })
        }
    }


    nextPage = () => {
        let {stepNumber, releaseVerification} = this.state
        let formLaneApplications = releaseVerification.formLaneApplications??[]
        if(stepNumber>=formLaneApplications.length-1){
            this.setState({
                confirmReleaseVerificationModal:true,
            })
            return;
        }

        let formLaneApplication = formLaneApplications[stepNumber];
        let formApplications = formLaneApplication.formApplications?formLaneApplication.formApplications:[]
        let failed = false ;
        for (let i = 0; i < formApplications.length ; i++) {
            let formApplication = formApplications[i]
            let form = formApplication.form?formApplication.form:{}
            form.error = undefined ;
            form.message = undefined ;
            if(form.mandatory && (isEmpty(formApplication.value) && isEmpty(formApplication.imageUrl))){
                form.error = true ;
                form.message = label.PleaseEnterAFieldValueVariable(form.title)
                failed = true ;
            }
            let subFormApplications = formApplication.subFormApplications?formApplication.subFormApplications:[]
            for (let j = 0; j < subFormApplications.length ; j++) {
                let subFormApplication = subFormApplications[j]
                let form = subFormApplication.form?subFormApplication.form:{}
                form.error = undefined ;
                form.message = undefined ;
                if(form.mandatory && (isEmpty(subFormApplication.value) && isEmpty(subFormApplication.imageUrl))){
                    form.error = true ;
                    form.message = label.PleaseEnterAFieldValueVariable(form.title)
                    failed = true ;
                }
                subFormApplication.form = form
                subFormApplications[j] = subFormApplication
            }
            formApplication.form = form
            formApplication.subFormApplications = subFormApplications
            formApplications[i] = formApplication
        }
        formLaneApplication.formApplications = formApplications
        formLaneApplications[stepNumber] = formLaneApplication
        releaseVerification.formLaneApplications = formLaneApplications

        this.setState({releaseVerification:releaseVerification}, () => {
            if(failed){
                return;
            }
            stepNumber = stepNumber+1;
            this.setState({stepNumber})
        })
    }

    confirmPostponeReleaseVerification(){
        this.setState({
            confirmReleaseVerificationCancelModal:true,
        })

    }


    previousPage = () => {
        let {stepNumber} = this.state
        if(stepNumber<=0){
            return
        }
        stepNumber = stepNumber-1;

        this.setState({stepNumber})
    }

    saveReleaseVerification=()=>{
        let {releaseVerification} = this.state
        this.post(Endpoint.API.RELEASE_VERIFICATION_SAVE, clone(releaseVerification), null, async (response)=>{
            if(response.code===200){
                this.successToast(label.SuccessSavingARelease);
                await this.fetchReleaseVerificationDetail()
            }else if(response.code===299){
                this.setState({
                    serialCodeHasBeenUsedModal : true ,
                    serialCodeHasBeenUsedMessage: response.message,
                    anotherMatchSerialReleaseVerification : response.data
                })
            }else{
                this.openFailedDialog(label.Warning, response.message, ()=>{})
            }
        }, true, false)
    }

    submitReleaseVerification=(releaseVerification, releaseVerificationStatus)=>{
        this.post(Endpoint.API.RELEASE_VERIFICATION_COMMIT+"/"+releaseVerificationStatus.id, clone(releaseVerification), null, (response)=>{
            if(response.code===200){
                const releaseVerification = response.data;
                const releaseVerificationStatus = releaseVerification.releaseVerificationStatus;
                this.successToast(label.SuccessUpdatingStatus)
                setTimeout(()=>{
                    this.props.history.push(OutgoingDashboardPage.ENDPOINT);
                }, 1000)
            }else{
                this.openFailedDialog(label.FailedToUpdateVerification, response.message, ()=>{})
            }
        }, true, false)
    }

    cancelReleaseVerification=(releaseVerification)=>{
        this.post(Endpoint.API.RELEASE_VERIFICATION_COMMIT+"/"+RELEASE_STATUS_POSTPONED, clone(releaseVerification), null, (response)=>{
            if(response.code===200){
                this.props.history.push(OutgoingDashboardPage.ENDPOINT);
            }else{
                this.openFailedDialog(label.FailedUpdatingStatus, response.message, ()=>{})
            }
        }, true, false)
    }



    render() {
        let {releaseVerification,  stepNumber, expandInfo, releaseVerificationStatus, releaseVerificationSuccessDialog, inspectionDetailModal,
            inspectionGuideModal, releaseVerificationEvent,commitReleaseVerificationSuccessDialog, confirmReleaseVerificationModal,
            releaseVerificationStatusSubmitOptions, confirmReleaseVerificationSubmitModal,
            confirmReleaseVerificationCancelModal, justOpen, customerInfoModal,
            serialCodeHasBeenUsedModal, anotherMatchSerialReleaseVerification,
            serialCodeHasBeenUsedMessage, tokenInputModal, generateSerialNumber, rectifierControllerSerialNumberInfoModal} = this.state

        // if(!assembly){
        //     assembly = {}
        // }

        let model = releaseVerification.model??{}
        let inspection = releaseVerification.inspection??{}
        let {assembly} = inspection

        let formLaneApplications = releaseVerification.formLaneApplications??[]
        let user = releaseVerification.user??{}
        let creator = releaseVerification.creator??{}
        // let user = getUser()
        return (
            <>
                {super.render()}
                <CustomerInfoUnchangeableModal
                    releaseVerification={releaseVerification}
                    showing={customerInfoModal}
                    onClose={()=>{
                        this.setState({
                            customerInfoModal:false
                        })
                    }}/>
                <InspectionGuideModal
                    model={model}
                    showing={inspectionGuideModal}
                    onClose={() => {
                        this.setState({
                            inspectionGuideModal:false,
                            customerInfoModal:justOpen?true:false,
                            justOpen:false
                        })
                    }}/>
                <InspectionDetailModal
                    show={inspectionDetailModal}
                    model={model}
                    inspection={inspection}
                    inspectionEvent={inspection.currentInspectionEvent}
                    onClose={() => {
                        this.setState({inspectionDetailModal:false})
                    }}/>
                <ConfirmReleaseVerificationFormModal
                    releaseVerification={releaseVerification}
                    show={confirmReleaseVerificationModal}
                    releaseVerificationStatusSubmitOptions={releaseVerificationStatusSubmitOptions}
                    onClickSubmit={(releaseVerificationStatus) => {
                        this.setState({
                            releaseVerification,
                            releaseVerificationStatus:releaseVerificationStatus,
                            confirmReleaseVerificationModal:false,
                            confirmReleaseVerificationSubmitModal:true
                        })
                    }}
                    onClickCancel={() => {
                        this.setState({confirmReleaseVerificationModal:false})
                    }}
                />
                <ConfirmReleaseVerificationSubmitModal
                    releaseVerification={releaseVerification}
                    releaseVerificationStatus={releaseVerificationStatus}
                    showing={confirmReleaseVerificationSubmitModal}
                    okCallback={(releaseVerification, releaseVerificationStatus)=>{
                        this.setState({
                            confirmReleaseVerificationSubmitModal:false
                        }, () => {
                            this.submitReleaseVerification(releaseVerification, releaseVerificationStatus)
                        })
                    }}
                    cancelCallback={()=>{
                        this.setState({
                            confirmReleaseVerificationSubmitModal:false
                        })
                    }}
                />
                <ConfirmReleaseVerificationCancelModal
                    releaseVerification={releaseVerification}
                    showing={confirmReleaseVerificationCancelModal}
                    okCallback={(releaseVerification)=>{
                        this.setState({
                            confirmReleaseVerificationCancelModal:false
                        }, () => {
                            this.cancelReleaseVerification(releaseVerification)
                        })
                    }}
                    cancelCallback={()=>{
                        this.setState({confirmReleaseVerificationCancelModal:false})
                    }}
                />
                {/*<ReleaseVerificationSuccessDialog*/}
                {/*    showing={releaseVerificationSuccessDialog}*/}
                {/*    title={label.Success}*/}
                {/*    message={label.SuccessUpdatingStatus}*/}
                {/*    generateSerialNumber={false}*/}
                {/*    releaseVerification={releaseVerification}*/}
                {/*    okCallback={()=>{*/}
                {/*        this.setState({*/}
                {/*            releaseVerificationSuccessDialog:false*/}
                {/*        },async ()=>{*/}
                {/*            await this.fetchReleaseVerificationDetail();*/}
                {/*        })*/}
                {/*    }}*/}
                {/*    goToDashboardCallback={()=>{*/}
                {/*        this.props.history.push("/")*/}
                {/*    }}*/}
                {/*    onClickPrint={()=>{}}*/}
                {/*/>*/}
                {/*<ReleaseVerificationSuccessDialog*/}
                {/*    showing={commitReleaseVerificationSuccessDialog}*/}
                {/*    title={label.SuccessSavingReleaseVerification}*/}
                {/*    releaseVerification={releaseVerification}*/}
                {/*    message={label.SuccessSavingReleaseVerification}*/}
                {/*    generateSerialNumber={generateSerialNumber}*/}
                {/*    okCallback={()=>{*/}
                {/*        this.setState({*/}
                {/*            commitReleaseVerificationSuccessDialog:false*/}
                {/*        },async ()=>{*/}
                {/*            await this.fetchReleaseVerificationDetail();*/}
                {/*        })*/}
                {/*    }}*/}
                {/*    goToDashboardCallback={()=>{*/}
                {/*        this.props.history.push("/")*/}
                {/*    }}*/}
                {/*    onClickPrint={()=>{*/}
                {/*        if(releaseVerification.printedCount>0){*/}
                {/*            tokenInputModal = true ;*/}
                {/*        }else{*/}
                {/*            tokenInputModal = false ;*/}
                {/*        }*/}
                {/*        this.setState({tokenInputModal}, () => {*/}
                {/*            if(tokenInputModal==false){*/}
                {/*                window.open(BASE_SERVER+Global.API.PRINT_SERIAL_NUMBER*/}
                {/*                    +"?startSerialNumber="+releaseVerification.serialCode+"&endSerialNumber="+releaseVerification.serialCode*/}
                {/*                    +"&userCode="+user.userCode+"&platform="+QC_INSPECTOR,"_blank")*/}
                {/*            }*/}
                {/*        })*/}
                {/*    }}*/}
                {/*/>*/}
                <Page
                    title={label.VerificationOf+" "+model.systemType}
                    breadcrumbs={[{ name: label.VerificationOf, active: true }]}>
                    <Row>
                        <Col>
                            <Card>
                                <PrimaryCardHeader content={(
                                    <React.Fragment>
                                        {label.ModelInformation}
                                        <ButtonGroup style={{marginLeft:'16px'}}>
                                            <Button
                                                outline
                                                className={"button-md-icon"}
                                                onClick={() => {
                                                    this.setState({
                                                        expandInfo:!expandInfo
                                                    })
                                                }}>
                                                {this.state.expandInfo?
                                                    (
                                                        <MdArrowDropUp/>
                                                    )
                                                    :
                                                    (
                                                        <MdArrowDropDown/>
                                                    )}
                                            </Button>
                                            &nbsp;
                                            <Button
                                                outline
                                                className="button-md-icon"
                                                color="secondary"
                                                onClick={() => {
                                                    this.setState({
                                                        customerInfoModal:true
                                                    })
                                                }}>
                                                {label.Customer}&nbsp;<FaUser/>
                                            </Button>
                                            &nbsp;
                                            <Button
                                                outline
                                                className={"button-md-icon"}
                                                color={"info"}
                                                onClick={() => {
                                                    this.setState({
                                                        inspectionGuideModal:true
                                                    })
                                                }}>
                                                {label.Instruction}&nbsp;<MdHelp/>
                                            </Button>
                                            &nbsp;
                                            <Button
                                                outline
                                                className={"button-md-icon"}
                                                color={"primary"}
                                                onClick={() => {
                                                    this.setState({
                                                        inspectionDetailModal:true
                                                    })
                                                }}>
                                                {label.Inspection}&nbsp;<BsListTask/>
                                            </Button>

                                        </ButtonGroup>
                                    </React.Fragment>
                                )}/>
                                <Collapse isOpen={expandInfo}>
                                    <CardBody>
                                        <Row>
                                            <Col md={3} sm={12}>
                                                <FormGroup>
                                                    <Label for="name">{label.SystemType}</Label>
                                                    <Input disabled type="text" name="title" value={model.systemType}/>
                                                </FormGroup>
                                            </Col>
                                            <Col md={3} sm={12}>
                                                <FormGroup>
                                                    <Label for="name">{label.Reference}</Label>
                                                    <Input disabled type="text" name="title" value={releaseVerification.reference}/>
                                                </FormGroup>
                                            </Col>
                                            <Col md={3} sm={12}>
                                                <FormGroup>
                                                    <Label for="name">{label.SerialCode}</Label>
                                                    <Input disabled type="text" name="title" value={inspection.serialCode}/>
                                                </FormGroup>
                                            </Col>
                                            <Col md={3} sm={12}>
                                                <FormGroup>
                                                    <Label for="name">{label.Creator}</Label>
                                                    <Input disabled type="text" name="title" value={creator.fullname}/>
                                                </FormGroup>
                                            </Col>
                                            <Col md={3} sm={12}>
                                                {/*<FormGroup>*/}
                                                {/*    <Label for="name">{label.CurrentReleaseVerificationStatus}</Label>*/}
                                                {/*    <Input disabled type="text" name="title" value={releaseVerificationStatus.label}/>*/}
                                                {/*</FormGroup>*/}
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col md={4} sm={12}>
                                                {/*<FormGroup>*/}
                                                {/*    <Label for="name">{label.PreviousReleaseVerificationPerformedBy}</Label>*/}
                                                {/*    <Input disabled type="text" name="title" value={previousUser.fullname?previousUser.fullname:"-"}/>*/}
                                                {/*</FormGroup>*/}
                                            </Col>
                                            <Col md={4} sm={12}>
                                                {/*<FormGroup>*/}
                                                {/*    <Label for="name">{label.PreviousReleaseVerificationStatus}</Label>*/}
                                                {/*    <Input disabled type="text" name="title" value={previousReleaseVerificationStatus.label?previousReleaseVerificationStatus.label:"-"}/>*/}
                                                {/*</FormGroup>*/}
                                            </Col>
                                            <Col md={4} sm={12}>
                                                {/*<FormGroup>*/}
                                                {/*    <Label for="name">{label.PreviousReleaseVerificationDate}</Label>*/}
                                                {/*    <Input disabled type="text" name="title" value={previousReleaseVerification.created?parseDate(previousReleaseVerification.created, DD_MM_YYYY_HH_MM_SS):"-"}/>*/}
                                                {/*</FormGroup>*/}
                                            </Col>
                                        </Row>
                                    </CardBody>
                                </Collapse>
                            </Card>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <Card>
                                <CardBody>
                                    <Row>
                                        <Col md={3} sm={12}>
                                            <Button block color={"danger"} onClick={(e) => {
                                                e.preventDefault()
                                                this.confirmPostponeReleaseVerification()
                                            }}>
                                                {label.PostponeVerification}&nbsp;<MdCancel/>
                                            </Button>
                                        </Col>
                                        <Col md={3} sm={12}>
                                            <Button block color={"purple"} onClick={(e) => {
                                                e.preventDefault()
                                                this.saveReleaseVerification()
                                            }}>
                                                {label.SaveVerification}&nbsp;<MdSave/>
                                            </Button>
                                        </Col>
                                        <Col md={3} sm={6}>
                                            <Button block color={stepNumber===0?"disabled":"warning"} className={"float-right"} onClick={(e) => {
                                                e.preventDefault()
                                                this.previousPage()
                                            }}>
                                                {label.PagePrevious}
                                            </Button>
                                        </Col>
                                        <Col md={3} sm={6}>
                                            <Button
                                                block
                                                color={"primary"}
                                                className={"float-right"}
                                                onClick={(e) => {
                                                    e.preventDefault()
                                                    this.nextPage()
                                            }}>
                                                {label.PageNext}
                                            </Button>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            <ReleaseVerificationFormLaneCheckWidget
                                                releaseVerification={releaseVerification}
                                                stepFormLaneId={formLaneApplications[stepNumber]?formLaneApplications[stepNumber].laneId:0}
                                                formLaneApplication={formLaneApplications[stepNumber]?formLaneApplications[stepNumber]:{}}/>
                                        </Col>
                                    </Row>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Page>
            </>
        );
    }
}

const ENDPOINT = "/releaseVerification/formCheck"
const TITLE = label.AssemblyInformation
const PAGE = {BASE_ENDPOINT: ENDPOINT, ENDPOINT: ENDPOINT+"/:reference", PAGE_CONF: {ENDPOINT, TITLE}}

export default Object.assign(ReleaseVerificationFormCheckPage, PAGE)